<template>
  <div class="scanCodeBox">
    <div id="wxImg">
      <img :src="'data:image/png;base64,' + wxImgSrc" alt="微信二维码" />
      <div class="upBox" v-if="wxUp" @click="wxRefresh">
        <span>二维码失效，请刷新页面</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "scanCode",
  props: {
    params: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      wxImgSrc: "",
      wxState: "",
      wxUp: false,
    };
  },
  async created () {

    await this.getWxCode(this.params.id)
  },
  beforeDestroy () {
    clearInterval(this.wxInter);
  },
  methods: {
    // 获取二维码地址
    async getWxCode (id) {
      const response = await this.catReq1Service("/wechat/get_bind_weChat_login_url", { userId: id }, "get")
      if (!response.success) {
        return;
      }
      this.wxImgSrc = response.result.urlBase64;
      this.wxState = response.result.state;
      this.wxInter = window.setInterval(this.getWXStatus, 1000);
    },
    /// 轮询 是否扫二维码
    async getWXStatus () {
      let that = this
      const response = await this.catReq1Service(
        "/wechat/get_openId",
        { state: this.wxState },
        "post",
        2
      )
      if (response.resultCode == "0") {
        this.wxUp = true;
        clearInterval(this.wxInter);
        return;
      }
      let data = response.result;
      if (data != null) {
        if (data.resultCode === "0") {
          clearInterval(this.wxInter);
          if (data.errorDesc === "用户无权登陆") {
            this.$message.closeAll();
            this.$message({
              message: "暂无登录权限，请联系管理员。或飞译官方客服：13717630007",
              type: "warning"
            });
            this.getWxCode(this.params.id);
            return
          }
          this.wxUp = true;
        } else {
          if (data.result.openId == "false") {
            that.$message.closeAll();
            that.$message({
              showClose: true,
              message: "该微信已绑定过用户，无法重复绑定。",
              type: "warning"
            });
            this.getWxCode(this.params.id);
            return
          } else {
            clearInterval(this.wxInter);
            this.$emit("confirm")
            // that.wxLogin(data.result.openId);
          }
        }
      }

    },
  }
};
</script>

<style lang="less" scoped>
.scanCodeBox {
  margin: 10px 80px;
}
</style>